(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabLog', LabLog);

    LabLog.$inject = ['$resource'];

    function LabLog ($resource) {
        var resourceUrl =  'api/lab-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
